import { Row } from '@arkestro/arkestro-design-system';
import CompanyAssignmentWizard from './vendor/CompanyAssignmentWizard/CompanyAssignmentWizard';
import { VendorOnboardReview } from './vendor/VendorOnboardReview/VendorOnboardReview';
import VendorWelcomeGuide from './vendor/VendorWelcomeGuide/VendorWelcomeGuide';
import VendorProfileFields from './vendor/VendorProfileFields/VendorProfileFields';
import VendorOnboardProvider, { VendorOnboardContext } from './vendor/VendorOnboardProvider/VendorOnboardProvider';

const VendorOnBoard = () => (
  <VendorOnboardProvider>
    <VendorOnboardContext.Consumer>
      {({ currentOrgStep, currentStepName, updateOnboardStep, progress, setProperty, newVendorOrgParams, updateOrgId, userParams, newOrgCreated }) => {
        const passedProps = {
          currentOrgStep,
          currentStepName,
          newOrgCreated,
          newVendorOrgParams,
          progress,
          setProperty,
          updateOnboardStep,
          updateOrgId,
          userParams
        };

        return (
          <div id='vendor-onboard-wrapper'>
            <Row align='middle' justify='center'>
              {currentStepName === 'intro' && <VendorProfileFields {...passedProps} />}
              {currentStepName === 'company_assignment' && <CompanyAssignmentWizard {...passedProps} />}
              {currentStepName === 'review' && <VendorOnboardReview {...passedProps} />}
              {currentStepName === 'vendor_welcome' && <VendorWelcomeGuide {...passedProps} />}
            </Row>
          </div>
        );
      }}
    </VendorOnboardContext.Consumer>
  </VendorOnboardProvider>
);

export default VendorOnBoard;
